// Centralised lead-journey label + dot colour map. Used by V1 + V2 task
// cards and any other surface that needs to render the lead's lifecycle
// stage. Source of truth — do not duplicate inline.

export const getJourneyLabel = (status) => {
    const map = {
        NEW: 'New Lead',
        CONSULTATION_BOOKED: 'Consultation Booked',
        CONSULTATION_ATTENDED: 'Consultation Attended',
        TREATMENT_STARTED: 'Treatment Started',
        FAILED_TO_ATTEND_CONSULTATION: 'FTA',
        CLOSED: 'Completed Treatment',
        TODO: 'To Do',
        CALLBACK: 'Callback',
    };
    return map[status] || (status ? status.charAt(0) + status.toLowerCase().replace(/_/g, ' ').slice(1) : '');
};

export const getJourneyDot = (status) => {
    const map = {
        NEW: '#3b82f6',
        CONSULTATION_BOOKED: '#f59e0b',
        CONSULTATION_ATTENDED: '#8b5cf6',
        TREATMENT_STARTED: '#10b981',
        FAILED_TO_ATTEND_CONSULTATION: '#ef4444',
        CLOSED: '#6b7280',
        TODO: '#06b6d4',
        CALLBACK: '#f97316',
    };
    return map[status] || '#9ca3af';
};
